import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'mentoring',
    loadChildren: () => import('./mentoring/mentoring.module').then(m => m.MentoringModule)
  },
  {
    path: 'invite-to-speak',
    loadChildren: () => import('./presenting/presenting.module').then(m => m.PresentingModule)
  },
  {
    path: 'about',
    loadChildren: () => import('./about/about.module').then(m => m.AboutModule)
  },
  {
    path: 'education',
    loadChildren: () => import('./education/education.module').then(m=>m.EducationModule)
  },
  {
    path: 'work-experience',
    loadChildren: () => import('./workexperience/workexperience.module').then(m => m.WorkexperienceModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
